import { create } from 'zustand';
import { getLandingDataAction } from './action';
import { devtools, persist } from 'zustand/middleware';
import { LandingInfoDataType } from '../../Types/landing.type';

type LandingDataType = {
  isThereToken: boolean;
  setIsThereToken: (isThereToken: boolean) => void;
  smsUrl: string;
  landingData: LandingInfoDataType;
  landingLoading: boolean;
  landingError: boolean;
  setSmsUrlAction: (smsUrl: string) => void;
  getLandingDataAction: (body: {
    smartGuid: string;
    customerGuid: string;
    smsId: string;
  }) => Promise<LandingInfoDataType>;
};

const useLandingStore = create<LandingDataType>()(
  devtools(
    persist(
      (set) => ({
        isThereToken: true,
        setIsThereToken: (isThereToken) => set({ isThereToken }),
        smsUrl: null,
        landingData: null,
        landingError: false,
        landingLoading: false,
        setSmsUrlAction: (smsUrl) => set({ smsUrl }),
        getLandingDataAction: (body): Promise<LandingInfoDataType> =>
          getLandingDataAction(set, body)
      }),
      { name: 'landingStore', getStorage: () => localStorage }
    )
  )
);

export default useLandingStore;
